import {
  DashboardOutlined,
  TeamOutlined,
  UserOutlined,
  FileProtectOutlined,
  DollarOutlined,
  WarningOutlined,
  FieldTimeOutlined,
  AlertOutlined,
  BarChartOutlined,
  BankOutlined,
  SafetyOutlined,
  ShopOutlined,
  SettingOutlined,
  PlusOutlined,
  AuditOutlined,
  LockOutlined,
  FileTextOutlined
} from '@ant-design/icons';

// Configuration des pages avec titre, description, icône et couleur
const pageConfig = {
  // Dashboard
  '/dashboard': {
    title: 'Tableau de Bord',
    description: "Vue d'ensemble de l'activité Cap Assurances",
    icon: DashboardOutlined,
    gradient: 'linear-gradient(135deg, #1A2B5F 0%, #2A3E7A 50%, #4A8BC2 100%)',
    shadowColor: 'rgba(26, 43, 95, 0.3)'
  },

  // Clients
  '/dashboard/clients': {
    title: 'Gestion Clients',
    description: 'Clients et prospects',
    icon: TeamOutlined,
    gradient: 'linear-gradient(135deg, #52c41a 0%, #73d13d 50%, #95de64 100%)',
    shadowColor: 'rgba(82, 196, 26, 0.3)'
  },
  '/dashboard/client': {
    title: 'Détail Client',
    description: 'Informations détaillées du client',
    icon: UserOutlined,
    gradient: 'linear-gradient(135deg, #52c41a 0%, #73d13d 50%, #95de64 100%)',
    shadowColor: 'rgba(82, 196, 26, 0.3)'
  },
  '/dashboard/ajouter-client': {
    title: 'Nouveau Client',
    description: 'Enregistrer un nouveau client',
    icon: PlusOutlined,
    gradient: 'linear-gradient(135deg, #52c41a 0%, #73d13d 50%, #95de64 100%)',
    shadowColor: 'rgba(82, 196, 26, 0.3)'
  },

  // Contrats
  '/dashboard/contrats': {
    title: 'Gestion Contrats',
    description: "Polices d'assurance",
    icon: FileProtectOutlined,
    gradient: 'linear-gradient(135deg, #2f54eb 0%, #597ef7 50%, #85a5ff 100%)',
    shadowColor: 'rgba(47, 84, 235, 0.3)'
  },
  '/dashboard/contrat': {
    title: 'Détail Contrat',
    description: 'Informations détaillées du contrat',
    icon: FileProtectOutlined,
    gradient: 'linear-gradient(135deg, #2f54eb 0%, #597ef7 50%, #85a5ff 100%)',
    shadowColor: 'rgba(47, 84, 235, 0.3)'
  },
  '/dashboard/ajouter-contrat': {
    title: 'Nouveau Contrat',
    description: 'Créer une nouvelle police d\'assurance',
    icon: PlusOutlined,
    gradient: 'linear-gradient(135deg, #2f54eb 0%, #597ef7 50%, #85a5ff 100%)',
    shadowColor: 'rgba(47, 84, 235, 0.3)'
  },

  // Règlements
  '/dashboard/reglements': {
    title: 'Règlements',
    description: 'Paiements et versements',
    icon: DollarOutlined,
    gradient: 'linear-gradient(135deg, #13c2c2 0%, #36cfc9 50%, #87e8de 100%)',
    shadowColor: 'rgba(19, 194, 194, 0.3)'
  },
  '/dashboard/ajouter-reglement': {
    title: 'Nouveau Règlement',
    description: 'Enregistrer un paiement',
    icon: PlusOutlined,
    gradient: 'linear-gradient(135deg, #13c2c2 0%, #36cfc9 50%, #87e8de 100%)',
    shadowColor: 'rgba(19, 194, 194, 0.3)'
  },

  // Échéances
  '/dashboard/echeances': {
    title: 'Échéances',
    description: 'Contrats à renouveler',
    icon: FieldTimeOutlined,
    gradient: 'linear-gradient(135deg, #2f54eb 0%, #597ef7 50%, #85a5ff 100%)',
    shadowColor: 'rgba(47, 84, 235, 0.3)'
  },

  // Impayés
  '/dashboard/impayes': {
    title: 'Impayés',
    description: 'Soldes en attente',
    icon: WarningOutlined,
    gradient: 'linear-gradient(135deg, #faad14 0%, #ffc53d 50%, #ffd666 100%)',
    shadowColor: 'rgba(250, 173, 20, 0.3)'
  },

  // Sinistres
  '/dashboard/sinistres': {
    title: 'Sinistres',
    description: 'Déclarations et suivi',
    icon: AlertOutlined,
    gradient: 'linear-gradient(135deg, #f5222d 0%, #ff4d4f 50%, #ff7875 100%)',
    shadowColor: 'rgba(245, 34, 45, 0.3)'
  },
  '/dashboard/sinistre': {
    title: 'Détail Sinistre',
    description: 'Informations détaillées du sinistre',
    icon: AlertOutlined,
    gradient: 'linear-gradient(135deg, #f5222d 0%, #ff4d4f 50%, #ff7875 100%)',
    shadowColor: 'rgba(245, 34, 45, 0.3)'
  },
  '/dashboard/ajouter-sinistre': {
    title: 'Nouveau Sinistre',
    description: 'Déclarer un sinistre',
    icon: PlusOutlined,
    gradient: 'linear-gradient(135deg, #f5222d 0%, #ff4d4f 50%, #ff7875 100%)',
    shadowColor: 'rgba(245, 34, 45, 0.3)'
  },

  // Bilans & États
  '/dashboard/bilans': {
    title: 'Bilans & États',
    description: 'Rapports et bordereaux',
    icon: BarChartOutlined,
    gradient: 'linear-gradient(135deg, #722ed1 0%, #9254de 50%, #b37feb 100%)',
    shadowColor: 'rgba(114, 46, 209, 0.3)'
  },

  '/dashboard/etat-clients': {
    title: 'Etat des Clients',
    description: 'Situation financiere des clients',
    icon: BarChartOutlined,
    gradient: 'linear-gradient(135deg, #722ed1 0%, #9254de 50%, #b37feb 100%)',
    shadowColor: 'rgba(114, 46, 209, 0.3)'
  },

  '/dashboard/bordereau-production': {
    title: 'Bordereau de Production',
    description: 'Production par agence sur periode',
    icon: BarChartOutlined,
    gradient: 'linear-gradient(135deg, #722ed1 0%, #9254de 50%, #b37feb 100%)',
    shadowColor: 'rgba(114, 46, 209, 0.3)'
  },

  // Compagnies
  '/dashboard/compagnies': {
    title: 'Compagnies',
    description: "Compagnies d'assurance partenaires",
    icon: BankOutlined,
    gradient: 'linear-gradient(135deg, #1A2B5F 0%, #2A3E7A 50%, #4A8BC2 100%)',
    shadowColor: 'rgba(26, 43, 95, 0.3)'
  },

  // Types d'assurance
  '/dashboard/types-assurance': {
    title: "Types d'Assurance",
    description: 'Catégories de produits d\'assurance',
    icon: SafetyOutlined,
    gradient: 'linear-gradient(135deg, #eb2f96 0%, #f759ab 50%, #ffadd2 100%)',
    shadowColor: 'rgba(235, 47, 150, 0.3)'
  },

  // Agences
  '/dashboard/agences': {
    title: 'Agences',
    description: 'Points de vente et agences',
    icon: ShopOutlined,
    gradient: 'linear-gradient(135deg, #fa8c16 0%, #ffa940 50%, #ffc069 100%)',
    shadowColor: 'rgba(250, 140, 22, 0.3)'
  },

  // Paramétrages
  '/dashboard/parametrages': {
    title: 'Paramétrages',
    description: 'Configuration du système',
    icon: SettingOutlined,
    gradient: 'linear-gradient(135deg, #595959 0%, #8c8c8c 50%, #bfbfbf 100%)',
    shadowColor: 'rgba(89, 89, 89, 0.3)'
  },

  // Administration
  '/dashboard/gestion-admins': {
    title: 'Administrateurs',
    description: 'Gestion des comptes administrateurs',
    icon: TeamOutlined,
    gradient: 'linear-gradient(135deg, #595959 0%, #8c8c8c 50%, #bfbfbf 100%)',
    shadowColor: 'rgba(89, 89, 89, 0.3)'
  },
  '/dashboard/ajouter-admin': {
    title: 'Nouvel Administrateur',
    description: 'Créer un nouveau compte administrateur',
    icon: PlusOutlined,
    gradient: 'linear-gradient(135deg, #595959 0%, #8c8c8c 50%, #bfbfbf 100%)',
    shadowColor: 'rgba(89, 89, 89, 0.3)'
  },

  // Rôles
  '/dashboard/roles': {
    title: 'Rôles',
    description: 'Gestion des rôles et permissions',
    icon: LockOutlined,
    gradient: 'linear-gradient(135deg, #722ed1 0%, #9254de 50%, #b37feb 100%)',
    shadowColor: 'rgba(114, 46, 209, 0.3)'
  },
  '/dashboard/ajouter-role': {
    title: 'Nouveau Rôle',
    description: 'Créer un nouveau rôle',
    icon: PlusOutlined,
    gradient: 'linear-gradient(135deg, #722ed1 0%, #9254de 50%, #b37feb 100%)',
    shadowColor: 'rgba(114, 46, 209, 0.3)'
  },

  // Audit
  '/dashboard/audit-log': {
    title: "Journal d'Audit",
    description: 'Traçabilité des actions',
    icon: AuditOutlined,
    gradient: 'linear-gradient(135deg, #1890ff 0%, #40a9ff 50%, #69c0ff 100%)',
    shadowColor: 'rgba(24, 144, 255, 0.3)'
  },

  // Profil
  '/dashboard/profile': {
    title: 'Mon Profil',
    description: 'Gérez vos informations personnelles',
    icon: UserOutlined,
    gradient: 'linear-gradient(135deg, #1A2B5F 0%, #2A3E7A 50%, #4A8BC2 100%)',
    shadowColor: 'rgba(26, 43, 95, 0.3)'
  },
};

// Fonction pour obtenir la config d'une page
export const getPageConfig = (pathname) => {
  // Correspondance exacte d'abord
  if (pageConfig[pathname]) {
    return pageConfig[pathname];
  }

  // Pour les routes avec paramètres (ex: /dashboard/client/123)
  const pathParts = pathname.split('/');
  if (pathParts.length >= 3) {
    const basePath = `/${pathParts[1]}/${pathParts[2]}`;
    if (pageConfig[basePath]) {
      return pageConfig[basePath];
    }
  }

  // Config par défaut
  return {
    title: 'Cap Assurances',
    description: 'Backoffice de gestion',
    icon: DashboardOutlined,
    gradient: 'linear-gradient(135deg, #1A2B5F 0%, #2A3E7A 50%, #4A8BC2 100%)',
    shadowColor: 'rgba(26, 43, 95, 0.3)'
  };
};

export default pageConfig;
